window._uxa = window._uxa || [];
import {ContentSquareVars} from './contentsquareVars.js';
new ContentSquareVars(window.gtmData, window.gtmPageData).init();
